import React, { useEffect, useState } from "react";
import { FlexContainer, MedCol50 } from "../common/Flex";
import { ControlBox, ControlBoxHeader, ControlBoxLabel } from "../common/ControlBox";
import RadioOption from "./RadioOption";
import styled from "styled-components";
import api from '../../utils/api';

interface Style {
  id: number;
  name: string;
  description: string;
}

interface StyleControlBoxProps {
  value: string;
  onChange: (value: string) => void;
  onLoaded: () => void;
}

const StyleFlexContainer = styled(FlexContainer)`
  gap: 10px;
`;

const StyleControlBox: React.FC<StyleControlBoxProps> = ({ value, onChange, onLoaded }) => {
  const [styles, setStyles] = useState<Style[]>([]);

  useEffect(() => {
    const fetchStyles = async () => {
      try {
        const response = await api.get("styles");
        setStyles(response.data);
        onLoaded();
      } catch (err) {
        console.error("Failed to load styles", err);
      }
    };

    fetchStyles();
  }, [onLoaded]);

  useEffect(() => {
    if (styles.length > 0 && !value) {
      onChange(styles[0].id.toString());
    }
  }, [styles, value, onChange]);

  return (
    <ControlBox>
      <ControlBoxHeader>
        <ControlBoxLabel>3.</ControlBoxLabel>
        Style
      </ControlBoxHeader>
      <StyleFlexContainer>
        {styles.map((style) => (
          <MedCol50 key={style.id}>
            <RadioOption
              name="selectStyle"
              id={`style-${style.id}`}
              value={style.id.toString()}
              checked={value === style.id.toString()}
              onChange={() => onChange(style.id.toString())}
            >
              <p dangerouslySetInnerHTML={{ __html: style.description }}>
              </p>
            </RadioOption>
          </MedCol50>
        ))}
      </StyleFlexContainer>
    </ControlBox>
  );
};

export default StyleControlBox;